import React from "react";
import ProductAnalysisShadow from "./ProductAnalysisShadow";

// 商品名分析（RN-161）: プロトの「商品名別（KW）」ビューを単独表示する。
export default function ProductNameAnalysisPage() {
    return <ProductAnalysisShadow views={["kw"]} defaultView="kw" />;
}
